module.exports = "/_next/static/images/7ffd16ad6f308b447b96604de0b49918-phone-lg.png.webp";